module.exports = __webpack_public_path__ + "images/3707def37d3e68074a98cfd0f053aa26.gif";